// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `dialog {
  all: unset;
}

.window {
  position: absolute;
  z-index: 1000;
  filter: drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.1)),
    drop-shadow(2px 0px 36px rgba(0, 0, 0, 0.07));
  border-radius: 4px;
  display: none;
  max-height: 100vh;
  background: #f6f9fb;
}

.window-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

.window__header-content {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
  }

.window__buttons {
    padding-left: 8px;
    padding-right: 8px;
    display: flex;
    width: 82px;
  }

.window__body {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;
  }

.window[open] {
    display: block;
  }
`, "",{"version":3,"sources":["webpack://./src/components/Module/Window/style.scss"],"names":[],"mappings":"AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb;iDAC+C;EAC/C,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAwB;AAmC1B;;AAjCE;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;AAEA;IACE,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;EAChB;;AAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,WAA4B;EAC9B;;AAEA;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,cAAc;EAChB;;AAEA;IACE,cAAc;EAChB","sourcesContent":["@import '../../../../assets/scss/variables.scss';\n\ndialog {\n  all: unset;\n}\n\n.window {\n  position: absolute;\n  z-index: 1000;\n  filter: drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.1)),\n    drop-shadow(2px 0px 36px rgba(0, 0, 0, 0.07));\n  border-radius: 4px;\n  display: none;\n  max-height: 100vh;\n  background: $white-light;\n\n  &-container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n  }\n\n  &__header-content {\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n    align-items: center;\n    flex-shrink: 0;\n  }\n\n  &__buttons {\n    padding-left: 8px;\n    padding-right: 8px;\n    display: flex;\n    width: $window-buttons-width;\n  }\n\n  &__body {\n    background: #ffffff;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    overflow: auto;\n  }\n\n  &[open] {\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
